// @ts-nocheck
/**
 * BackendErrorBanner — global connectivity indicator.
 *
 * Renders a thin red strip at the top of the app shell ONLY while the
 * backend is erroring (network failure or 5xx), and nothing at all when
 * things are healthy. State comes from the axios interceptor via the
 * `backendHealth` store, so any failing request on any page surfaces here.
 */
import { useSyncExternalStore } from 'react';
import { subscribeBackendHealth, getBackendHealth } from '../api/backendHealth';

export function BackendErrorBanner() {
  const health = useSyncExternalStore(subscribeBackendHealth, getBackendHealth);

  if (health.status !== 'error') return null;

  return (
    <div
      role="alert"
      className="bg-accent/10 border-b border-accent/30 text-accent"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-1.5 flex items-center gap-2 text-xs font-medium">
        <span className="inline-block h-2 w-2 rounded-full bg-accent flex-shrink-0" />
        <span className="truncate">{health.message}</span>
      </div>
    </div>
  );
}
